(() => {
  const STYLE_ID = 'es-product-thumbnails-style';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .es-product-thumbnails{display:flex;gap:10px;align-items:center;overflow-x:auto;padding:12px 2px 4px;scrollbar-width:thin;scroll-snap-type:x proximity}
      .es-product-thumbnails__button{appearance:none;border:1px solid #e7e4de;background:#fff;border-radius:8px;padding:3px;width:64px;height:64px;flex:0 0 64px;cursor:pointer;overflow:hidden;transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease;scroll-snap-align:start}
      .es-product-thumbnails__button:hover{border-color:#b49a62;transform:translateY(-1px)}
      .es-product-thumbnails__button[aria-selected='true']{border-color:#1c1c1c;box-shadow:0 0 0 1px #1c1c1c}
      .es-product-thumbnails__button img{display:block;width:100%;height:100%;object-fit:contain;background:#fff;border-radius:5px}
      @media(max-width:749px){.es-product-thumbnails{gap:8px;padding-top:10px}.es-product-thumbnails__button{width:52px;height:52px;flex-basis:52px}}
    `;
    document.head.appendChild(style);
  }

  function buildGallery(gallery) {
    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow || gallery.querySelector('.es-product-thumbnails')) return;

    const nativeThumbs = gallery.querySelector('slideshow-controls[thumbnails]');
    if (nativeThumbs) return;

    const slides = [...slideshow.querySelectorAll('slideshow-slide')].filter((slide) => !slide.hasAttribute('hidden'));
    if (slides.length <= 1) return;

    const row = document.createElement('div');
    row.className = 'es-product-thumbnails';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Product images');

    const buttons = slides.map((slide, index) => {
      const source = slide.querySelector('img');
      if (!source) return null;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'es-product-thumbnails__button';
      button.setAttribute('aria-label', `View product image ${index + 1}`);
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      const image = document.createElement('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt || '';
      image.loading = 'lazy';
      button.appendChild(image);
      button.addEventListener('click', (event) => {
        const slideId = slide.getAttribute('slide-id');
        if (typeof slideshow.select === 'function') {
          slideshow.select(slideId ? { id: slideId } : index, event);
        } else {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        buttons.forEach((item, i) => item?.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      });
      return button;
    }).filter(Boolean);

    if (buttons.length <= 1) return;
    buttons.forEach((button) => row.appendChild(button));

    const container = slideshow.closest('media-gallery') || gallery;
    container.appendChild(row);

    const observer = new MutationObserver(() => {
      const visible = slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
      if (visible >= 0) buttons.forEach((button, i) => button.setAttribute('aria-selected', i === visible ? 'true' : 'false'));
    });
    slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] }));
  }

  function init() {
    ensureStyles();
    document.querySelectorAll('main[data-template^="product"] media-gallery').forEach(buildGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
